import { CoveringDTO } from './CoveringDTO';
import { UtilityDTO } from './UtilityDTO';

export class WallDTO {
  public id?: number;
  public uuid: string;
  public type: string;

  public interiorCorners: string[];
  public exteriorCorners: string[];

  public utilityIds: number[];

  public thickness: number;
  public wallCovering: CoveringDTO;

  constructor(
    uuid: string,
    type: string,
    interiorCorners: string[],
    exteriorCorners: string[],
    utilities: number[],
    thickness: number,
    wallCovering: CoveringDTO,
    id?: number,
  ) {
    this.id = id;
    this.uuid = uuid;
    this.type = type;
    this.interiorCorners = interiorCorners;
    this.exteriorCorners = exteriorCorners;
    this.thickness = thickness;
    this.utilityIds = utilities;
    this.wallCovering = wallCovering;
  }
}
